import { ErrorBoundary } from "react-error-boundary";
import Routes from './Routes';
import Page from './components/Page';
import ErrorFallBackUI from './components/ErrorFallBackUI';
import ReactGA from "react-ga4";
import 'aos/dist/aos.css';

const App = (): JSX.Element => {

  // Initialize Google Analytics
  let gaMeasurementId = process.env.REACT_APP_GOOGLE_ANALYTIC_GA4_MEASUREMENT_ID || 'G-PWMSGGL6SZ';
  if (gaMeasurementId) {
    ReactGA.initialize(gaMeasurementId);
  } else {
    console.error("Google Analytics Measurement ID is not defined.");
  }

  //set up browser title
  const pageTitle = 'Welcome to OCPF';
  document.title = pageTitle;

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallBackUI}
    >
       <Page>
        <Routes />
      </Page>
    </ErrorBoundary>
  );
};

export default App;
